export default __webpack_public_path__ + "public/images/services/Chat.png?844d6fd7";